<template>
  <section class="table-bar" :aria-label="$t('Tài Xỉu table selector')">
    <DiceLauncher class="table-bar__identity" active @click="$emit('close')" />
    <TableChips
      class="table-bar__tables"
      :tables="tables"
      :is-active="isActive"
      @select="$emit('select-table', $event)"
    />
    <label class="quick-toggle">
      <input type="checkbox" :checked="quickPlayEnabled" @change="toggleQuickPlay" />
      <i aria-hidden="true"></i>
      <span>{{ $t('Quickplay') }}</span>
    </label>
  </section>
</template>

<script>
import DiceLauncher from './dice-launcher.vue';
import TableChips from './table-chips.vue';

export default {
  components: {
    DiceLauncher,
    TableChips,
  },
  props: {
    tables: {
      type: Array,
      required: true,
    },
    activeProduct: {
      type: String,
      required: true,
    },
    activeTableId: {
      type: String,
      default: '',
    },
    quickBetTableId: {
      type: String,
      default: '',
    },
    quickPlayEnabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleQuickPlay(event) {
      this.$emit('quick-play', event.target.checked);
    },
    isActive(tableId) {
      return (
        (this.activeProduct === 'tai-xiu' && this.activeTableId === tableId) ||
        this.quickBetTableId === tableId
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.table-bar {
  width: 100%;
  // v2.1: the footer's first row (34), on the footer's own fill.
  height: 34px;
  min-height: 34px;
  box-sizing: border-box;
  color: #fff;
  background-color: $ga-rail-bg;
  padding: 4px 10px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 0;
  border-top: 1px solid $ga-border-default;
  box-shadow: none;
}

.table-bar__identity {
  padding: 0
}

.table-bar__tables {
  // Chip styling lives in table-chips.vue; the bar only owns the track it sits in.
  min-width: 0;
  flex: 1;
}

// The label sits left of the switch on one line, which is what lets the bar be 44px.
.quick-toggle {
  height: 22px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  margin: 0;
  cursor: pointer;

  input {
    position: absolute;
    opacity: 0;
  }

  span {
    order: -1;
    color: $ga-text-muted;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    line-height: 1;
    white-space: nowrap;
    text-transform: uppercase;
  }

  i {
    width: 34px;
    height: 20px;
    box-sizing: border-box;
    border: 0;
    border-radius: 999px;
    background: $ga-navy-600;
    position: relative;
    transition: background 0.2s ease, border-color 0.2s ease;

    &::after {
      content: '';
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #fff;
      position: absolute;
      top: 50%;
      left: 2px;
      transform: translateY(-50%);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
      transition: transform 0.2s ease;
    }
  }

  input:checked + i {
    background: $ga-gold-500;

    &::after {
      transform: translate(14px, -50%);
    }
  }

  input:checked ~ span {
    color: $ga-gold-300;
  }
}

@media screen and (max-width: 390px) {
  .table-bar {
    padding-right: 10px;
    padding-left: 10px;
  }
}
</style>
